import { render } from "./OrangeButton.vue?vue&type=template&id=130c2b5e&scoped=true"
import script from "./OrangeButton.vue?vue&type=script&lang=js"
export * from "./OrangeButton.vue?vue&type=script&lang=js"

import "./OrangeButton.vue?vue&type=style&index=0&id=130c2b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130c2b5e"]])

export default __exports__